export default {
      id: "ic_important_bullhorn-usage",
      viewBox: "0 0 26 26",
      url: "/" + "images/icons.3.109.2.svg#ic_important_bullhorn-usage",
      toString: function () {
        return this.url;
      }
    }